export default __webpack_public_path__ + "static/media/feedback_excellent_01.fddc76a1.png";